var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"Lrtmbmh6XRPg8gW3si4Ex"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

if (Math.random() < 0.05) {
  Sentry.init({
    dsn: 'https://7b99f20d54e5c18e8e50b4d5bbf354cf@sentry.multitool.cloud/6',
    tracesSampleRate: 1.0,
    debug: false,
  });
}
